import type { SovereignProject } from './domain';
import { sovereignSchemaVersion } from './domain';

interface LegacyProjectV0 {
  readonly schemaVersion: 0;
  readonly id: string;
  readonly savedAt: string;
  readonly graph: SovereignProject['graph'];
  readonly records?: SovereignProject['sources'];
}

const isRecord = (value: unknown): value is Readonly<Record<string, unknown>> =>
  value !== null && !Array.isArray(value) && typeof value === 'object';

export const migrateProject = (value: unknown): SovereignProject => {
  if (!isRecord(value) || typeof value.schemaVersion !== 'number')
    throw new Error('Project payload has no readable schema version.');
  if (value.schemaVersion > sovereignSchemaVersion)
    throw new Error('Project was created by a newer Noemir version.');
  if (value.schemaVersion === 0) {
    const legacy = value as unknown as LegacyProjectV0;
    return {
      schemaVersion: sovereignSchemaVersion,
      projectId: legacy.id,
      savedAt: legacy.savedAt,
      graph: legacy.graph,
      sources: legacy.records ?? [],
      neuralArtifacts: [],
      analysis: [],
    };
  }
  const project = value as unknown as SovereignProject;
  if (
    typeof project.projectId !== 'string' ||
    typeof project.savedAt !== 'string' ||
    !isRecord(project.graph) ||
    !Array.isArray(project.sources) ||
    !Array.isArray(project.neuralArtifacts) ||
    !Array.isArray(project.analysis)
  )
    throw new Error('Project payload does not satisfy the local v1 contract.');
  return project;
};
